// *** Toastify plugin options
const toastifyPluginOptions = {
    position: "bottom-right",
    delay: 200
};

export default toastifyPluginOptions;
